// extracted by mini-css-extract-plugin
module.exports = {"vPortFoiloTypeN2":"style_vPortFoiloTypeN2__398o0","vSubmitPortN2":"style_vSubmitPortN2__2Jjk8"};